import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'topo-workflow-step-display',
    templateUrl: './workflow-step-display.component.html',
    styleUrls: ['./workflow-step-display.component.scss'],
    standalone: false
})
export class WorkflowStepDisplayComponent implements OnInit {
  @Input() htmlColorCode = '#DDDDDD';
  @Input() label="string";

  constructor() {}

  ngOnInit(): void {}
}
